
 export function SettingChipContract(contrato){
    const fimContratoDate = contrato.fim_contrato ? new Date(contrato.fim_contrato) : null;
    const dataValida = fimContratoDate && !isNaN(fimContratoDate.getTime());
    const diferencaTempo = dataValida ? fimContratoDate.getTime() - new Date().getTime() : null;
    const diferencaDias =diferencaTempo !== null ? Math.ceil(diferencaTempo / (1000 * 60 * 60 * 24)) : null;
    const destacarVermelho = diferencaDias !== null && diferencaDias < 6;
    const destacarAmarelo = diferencaDias !== null && diferencaDias >= 6 && diferencaDias < 31;
    const destacarAzul = diferencaDias !== null && diferencaDias >= 31 && diferencaDias < 61;

 return obterConfiguracaoChip();

function obterConfiguracaoChip() {
        if (destacarVermelho) {
            const textoDias = diferencaDias <= 0? 'Vencido': `Crítico: ${diferencaDias} ${diferencaDias === 1 ? 'dia' : 'dias'}`;
            return { label: textoDias, color: 'error' };
        }
        if (destacarAmarelo) return { label: `Atenção: ${diferencaDias} dias`, color: 'warning' };
        if (destacarAzul) return { label: `Planejamento: ${diferencaDias} dias`, color: 'info' };
        return {
            label: contrato.fim_contrato ? `Regular: ${diferencaDias} dias` : 'Sem Prazo',
            color: 'default',
        };
}
}